// true = Biden, false = Trump
const matrix = [
  [true, true, false],
  [true, true, false],
  [true, false, false],
];

export default matrix;
